module.exports = __webpack_public_path__ + "static/media/ccna-logo.70a88869.jpg";